import { LoaderType } from 'editor/src/store/app/types';
import { RootState } from 'editor/src/store/index';

const isLoaderActive = (state: RootState, loaderType: LoaderType) => state.app.activeLoaders[loaderType];

export default isLoaderActive;
